"use client"

import styles from "./styles/ContentItemPage.module.scss";
import WatsonApi from "../backends/WatsonApi";
import useSWR from "swr";
import NotificationManager from "../components/notifications/NotificationManager";
import SchoolBlocksLoadingIndicator from "../components/utilities/SchoolBlocksLoadingIndicator";
import SafeRouter from "../components/utilities/SafeRouter";
import {getPaths} from "../utils/SchoolBlocksUtilities";
import {withoutLocaleInURI} from "../internationalization/i18nURI";
import AccordionItemModalContent from "../components/modals/AccordionModal/AccordionItemModalContent";
import {useStores} from "../stores/useStores";

export default function AccordionItemPage() {
    const {interfaceStore} = useStores();

    const pathSegments: string[] = getPaths(withoutLocaleInURI(interfaceStore.currentFullUrl));
    const contentItemId = pathSegments[pathSegments.length - 1];
    const orgId = pathSegments[pathSegments.length - 3];
    const terraceId = pathSegments[pathSegments.length - 2];

    const {data, isLoading} = useSWR(`contentItem/${contentItemId}`, async () => {
        try {
            const client = await WatsonApi();
            const result = await client.apis.organizations.organizations_terraces_accordion_items_read({
                organization_pk: orgId,
                terrace_pk: terraceId,
                id: contentItemId,
                expand: ["content_html"],
            });
            return result.obj;
        } catch (e) {
            NotificationManager.error(e.response.body.detail);
        }
    }, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
    });

    return <div className={styles.container}>
        {isLoading ? <div className={styles.loadingIndicator}>
            <SchoolBlocksLoadingIndicator fill={"var(--fontColor)"} />
        </div> : data ? <AccordionItemModalContent
                closeFunction={async () => await SafeRouter.push(`/pages/${orgId}`)}
                itemObj={data}
                index={0}/>
            : <div className={styles.loadingIndicator}>Accordion Item not found.</div>}
    </div>
}
